<template>
  <div>
    <!-- <pre>{{$v}} </pre>-->

    <div class="panel panel-primary">
      <div class="panel-heading PanelHeadingCaption roundedcornerdiv">
        Homestead Deduction
      </div>
      <div
        class="panel-body"
        :class="{
          error:
            $v.HomesteadQuestionnaire.OwnershipStatus.$invalid &&
            this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
        }"
      >
        <div class="row Q_Row">
          <div class="col">
            <label class="Questionniare_Label subheaderlabel"
              >Residence Status</label
            >
          </div>
        </div>
        <div class="row Q_Row">
          <div class="col-sm-7 radiobuttons">
            <div class="radio">
              <label>
                <input
                  type="radio"
                  id="Own"
                  name="HomesteadQuestionnaireOwnershipStatus_Own"
                  value="O"
                  v-model="$v.HomesteadQuestionnaire.OwnershipStatus.$model"
                />
                Own
              </label>
            </div>

            <div class="radio">
              <label>
                <input
                  type="radio"
                  id="HomesteadQuestionnaireOwnershipStatus_BuyingUnderContract"
                  name="HomesteadQuestionnaireOwnershipStatus"
                  value="B"
                  v-model="$v.HomesteadQuestionnaire.OwnershipStatus.$model"
                />
                Buying Under Recorded Contract
              </label>
            </div>

            <div class="radio">
              <label v-if="HomesteadQuestionnaire.OwnershipStatus == 'B'"
                >Contract Seller
                <input
                  :class="{
                    error:
                      $v.HomesteadQuestionnaire.ContractSeller.$invalid &&
                      this.HomesteadQuestionnaire
                        .Exemption_Questionnaire_Submitted
                  }"
                  type="text"
                  id="HomesteadQuestionnaireOwnershipStatus_BuyingUnderContract_Buyer"
                  name="HomesteadQuestionnaireOwnershipContractedBuyer"
                  maxlength="50"
                  v-if="HomesteadQuestionnaire.OwnershipStatus == 'B'"
                  v-model="$v.HomesteadQuestionnaire.ContractSeller.$model"
                />
              </label>
            </div>

            <div class="radio">
              <label>
                <input
                  type="radio"
                  id="CooperativeHousing"
                  name="HomesteadQuestionnaireshipStatus_CooperativeHousingCorp"
                  value="E"
                  v-model="$v.HomesteadQuestionnaire.OwnershipStatus.$model"
                />
                Entitled to occupy as a tenant-stockholder of a Cooperative
                Housing Corp.
              </label>
            </div>

            <div class="radio">
              <label>
                <input
                  type="radio"
                  id="PersonalResidenceTrust"
                  name="HomesteadQuestionnaireshipStatus_PersonalTrust"
                  value="R"
                  v-model="$v.HomesteadQuestionnaire.OwnershipStatus.$model"
                />
                Right to occupy under a qualified personal residence trust
              </label>
            </div>

            <div class="radio">
              <label>
                <input
                  type="radio"
                  id="Shareholder"
                  name="HomesteadQuestionnaireshipStatus_PersonalTrust"
                  value="A"
                  v-model="$v.HomesteadQuestionnaire.OwnershipStatus.$model"
                />
                Am (are) the shareholder, partner, or member of the entity that
                owns the property.
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <label class="Questionniare_Label subheaderlabel"
            >Main Claimant Information</label
          >
        </div>
      </div>

      <div class="row Q_Row row-eq-height">
        <div class="col-sm-4 row-flex">
          <fieldset class="form-group col-flex">
            <label class="Questionniare_Label row-flex">Last 5 of SSN</label>
            <input
              class="form-control form-control-lg"
              :class="{
                error:
                  $v.HomesteadQuestionnaire.ClaimantSSNLastFive.$invalid &&
                  this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
              }"
              type="text"
              v-mask="'#####'"
              v-model="$v.HomesteadQuestionnaire.ClaimantSSNLastFive.$model"
              placeholder="99999"
            />
          </fieldset>
        </div>

        <div class="col-sm-4 row-flex">
          <fieldset class="form-group col-flex">
            <label class="Questionniare_Label row-flex"
              >Driver's License/State ID Number (Last 5):</label
            >
            <input
              id="inputDriversLicenseNumberClaimant"
              class="form-control form-control-lg row-flex"
              :class="{
                error:
                  $v.HomesteadQuestionnaire.ClaimantDLNumber.$invalid &&
                  this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
              }"
              type="text"
              v-mask="'#####'"
              v-model="$v.HomesteadQuestionnaire.ClaimantDLNumber.$model"
              placeholder="99999"
            />
          </fieldset>
        </div>

        <div class="col-sm-4 row-flex">
          <fieldset class="form-group col-flex">
            <label class="Questionniare_Label row-flex">Issuing State:</label>
            <select
              v-model="$v.HomesteadQuestionnaire.ClaimantDLState.$model"
              class="form-control form-control-lg statedropdown row-flex"
              :class="{
                error:
                  $v.HomesteadQuestionnaire.ClaimantDLState.$invalid &&
                  this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
              }"
            >
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
          </fieldset>
        </div>
      </div>

      <div
        class="row Q_Row"
        v-if="
          ($v.HomesteadQuestionnaire.ClaimantDLNumber.$invalid ||
            $v.HomesteadQuestionnaire.ClaimantSSNLastFive.$invalid) &&
            this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
        "
      >
        <div class="col">
          <!-- require either the DL number or SSN -->
          <span class="ValidateLabel"
            >Last 5 of SSN or Driver's License Number is required.</span
          >
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col-sm-4">
          <label class="Questionniare_Label">Is Claimant Married?</label>
        </div>
        <div class="col-sm-4">
          <button
            class="btnNotClicked"
            :class="
              HomesteadQuestionnaire.ClaimantMarried === 1 ? 'btnClicked' : ''
            "
            @click="HomesteadQuestionnaire.ClaimantMarried = 1"
            :disabled="HomesteadQuestionnaire.ClaimantMarried === 1"
          >
            Yes
          </button>
          <button
            class="btnNotClicked"
            :class="
              HomesteadQuestionnaire.ClaimantMarried === 0 ? 'btnClicked' : ''
            "
            @click="HomesteadQuestionnaire.ClaimantMarried = 0"
            :disabled="HomesteadQuestionnaire.ClaimantMarried === 0"
          >
            No
          </button>

          <span
            v-if="
              $v.HomesteadQuestionnaire.ClaimantMarried.$invalid &&
                this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
            "
            class="ValidateLabel"
            >This is Required</span
          >
        </div>
      </div>

      <div id="SpouseQuestions">
        <div class="row Q_Row">
          <div class="col">
            <label class="Questionniare_Label subheaderlabel"
              >Spouse or Additional Deeded Owner Information</label
            >
          </div>
        </div>

        <div
          class="row Q_Row"
          v-if="HomesteadQuestionnaire.ClaimantMarried != 1"
        >
          <div class="col">
            <div class="col">
              <input
                class="customcheckbox"
                type="checkbox"
                v-model="
                  HomesteadQuestionnaire.SpouseOrAdditionalDeededOwner_NotApplicable
                "
              />Not Applicable
            </div>
          </div>
        </div>

        <div
          class="row Q_Row row-eq-height"
          v-if="
            !this.HomesteadQuestionnaire
              .SpouseOrAdditionalDeededOwner_NotApplicable
          "
        >
          <div class="col-sm-4 row-flex">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label row-flex">First Name</label>
              <input
                id="inputName2"
                class="form-control form-control-lg row-flex"
                :class="{
                  error:
                    $v.HomesteadQuestionnaire.SpouseClaimantFirstName
                      .$invalid &&
                    this.HomesteadQuestionnaire
                      .Exemption_Questionnaire_Submitted
                }"
                type="text"
                maxlength="20"
                v-model="
                  $v.HomesteadQuestionnaire.SpouseClaimantFirstName.$model
                "
                placeholder="John"
              />
            </fieldset>
          </div>

          <div class="col-sm-4 row-flex">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label row-flex">Last Name</label>
              <input
                id="inputName3"
                class="form-control form-control-lg row-flex"
                :class="{
                  error:
                    $v.HomesteadQuestionnaire.SpouseClaimantLastName.$invalid &&
                    this.HomesteadQuestionnaire
                      .Exemption_Questionnaire_Submitted
                }"
                type="text"
                maxlength="35"
                v-model="
                  $v.HomesteadQuestionnaire.SpouseClaimantLastName.$model
                "
                placeholder="Doe"
              />
            </fieldset>
          </div>

          <div class="col-sm-4 row-flex">
            <fieldset class="form-group col-flex row-flex">
              <label class="Questionniare_Label">Telephone Number</label>
              <input
                id="inputTelephone"
                class="form-control form-control-lg row-flex"
                :class="{
                  error:
                    $v.HomesteadQuestionnaire.SpouseTelephoneNumber.$invalid &&
                    this.HomesteadQuestionnaire
                      .Exemption_Questionnaire_Submitted
                }"
                type="text"
                v-mask="'###-###-####'"
                v-model="$v.HomesteadQuestionnaire.SpouseTelephoneNumber.$model"
                placeholder="555-555-5555"
              />
            </fieldset>
          </div>
        </div>

        <!-- second spouse/deeded owner questionnaire row-->
        <div
          class="row Q_Row row-eq-height"
          v-if="
            !this.HomesteadQuestionnaire
              .SpouseOrAdditionalDeededOwner_NotApplicable
          "
        >
          <div class="col-sm-4 row-flex">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label row-flex">Last 5 of SSN</label>
              <input
                class="form-control form-control-lg row-flex"
                :class="{
                  error:
                    $v.HomesteadQuestionnaire.SpouseSSNLastFive.$invalid &&
                    this.HomesteadQuestionnaire
                      .Exemption_Questionnaire_Submitted
                }"
                type="text"
                v-mask="'#####'"
                v-model="$v.HomesteadQuestionnaire.SpouseSSNLastFive.$model"
                placeholder="99999"
              />
            </fieldset>
          </div>

          <div class="col-sm-4 row-flex">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label row-flex"
                >Driver's License/State ID Number (Last 5):</label
              >
              <input
                id="inputDriversLicenseNumberSpouse"
                class="form-control form-control-lg row-flex"
                :class="{
                  error:
                    $v.HomesteadQuestionnaire.SpouseDLNumber.$invalid &&
                    this.HomesteadQuestionnaire
                      .Exemption_Questionnaire_Submitted
                }"
                type="text"
                v-mask="'#####'"
                v-model="$v.HomesteadQuestionnaire.SpouseDLNumber.$model"
                placeholder
              />
            </fieldset>
          </div>

          <div class="col-sm-4 row-flex">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label row-flex">Issuing State:</label>
              <select
                v-model="$v.HomesteadQuestionnaire.SpouseDLState.$model"
                :class="{
                  error:
                    $v.HomesteadQuestionnaire.SpouseDLState.$invalid &&
                    this.HomesteadQuestionnaire
                      .Exemption_Questionnaire_Submitted
                }"
                class="form-control form-control-lg statedropdown row-flex"
              >
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
            </fieldset>
          </div>
        </div>

        <div
          class="row Q_Row"
          v-if="
            ($v.HomesteadQuestionnaire.SpouseDLNumber.$invalid ||
              $v.HomesteadQuestionnaire.SpouseDLNumber.$invalid) &&
              this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
          "
        >
          <div class="col">
            <!-- require either the DL number or SSN -->
            <span class="ValidateLabel"
              >Last 5 of SSN or Driver's License Number is required.</span
            >
          </div>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <label class="Questionniare_Label subheaderlabel"
            >Other Property Owned by Claimant</label
          >
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col-sm-4">
          <label class="Questionniare_Label"
            >Is claimant vacating a homestead?</label
          >
        </div>
        <div class="col-sm-4">
          <button
            class="btnNotClicked"
            :class="
              HomesteadQuestionnaire.ClaimaintVacatingHomestead === 1
                ? 'btnClicked'
                : ''
            "
            @click="HomesteadQuestionnaire.ClaimaintVacatingHomestead = 1"
            :disabled="HomesteadQuestionnaire.ClaimaintVacatingHomestead === 1"
          >
            Yes
          </button>
          <button
            class="btnNotClicked"
            :class="
              HomesteadQuestionnaire.ClaimaintVacatingHomestead === 0
                ? 'btnClicked'
                : ''
            "
            @click="HomesteadQuestionnaire.ClaimaintVacatingHomestead = 0"
            :disabled="HomesteadQuestionnaire.ClaimaintVacatingHomestead === 0"
          >
            No
          </button>

          <span
            v-if="
              $v.HomesteadQuestionnaire.ClaimaintVacatingHomestead.$invalid &&
                this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
            "
            class="ValidateLabel"
            >This is Required</span
          >
        </div>
      </div>

      <div
        class="row Q_Row"
        v-if="this.HomesteadQuestionnaire.ClaimaintVacatingHomestead == 1"
      >
        <div class="col-sm-4">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Vacated Property Address:</label>
            <input
              id="inputVacatedHomesteadAddress"
              type="text"
              maxlength="150"
              class="form-control form-control-lg"
              :class="{
                error:
                  $v.HomesteadQuestionnaire.VacatedHomesteadAddress.$invalid &&
                  this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
              }"
              v-model="$v.HomesteadQuestionnaire.VacatedHomesteadAddress.$model"
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col-sm-4">
          <label class="Questionniare_Label"
            >Does Claimant Own Property Elsewhere?</label
          >
        </div>
        <div class="col-sm-4">
          <button
            class="btnNotClicked"
            :class="
              HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere === 1
                ? 'btnClicked'
                : ''
            "
            @click="HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere = 1"
            :disabled="
              HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere === 1
            "
          >
            Yes
          </button>
          <button
            class="btnNotClicked"
            :class="
              HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere === 0
                ? 'btnClicked'
                : ''
            "
            @click="HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere = 0"
            :disabled="
              HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere === 0
            "
          >
            No
          </button>

          <span
            v-if="
              $v.HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere
                .$invalid &&
                this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
            "
            class="ValidateLabel"
            >This is Required</span
          >
        </div>
      </div>

      <div
        class="row Q_Row"
        v-if="this.HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere == 1"
      >
        <div class="col-sm-4">
          <fieldset class="form-group">
            <label class="Questionniare_Label">State and County:</label>
            <textarea
              id="inputStateCountyAndTownship"
              maxlength="50"
              class="form-control form-control-lg"
              :class="{
                error:
                  $v.HomesteadQuestionnaire.OtherPropertyStateCountyTownship
                    .$invalid &&
                  this.HomesteadQuestionnaire.Exemption_Questionnaire_Submitted
              }"
              v-model="
                $v.HomesteadQuestionnaire.OtherPropertyStateCountyTownship
                  .$model
              "
            />
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueMask from "v-mask";

import {
  required,
  requiredIf,
  decimal,
  minValue,
  email,
  minLength
} from "vuelidate/lib/validators";

export function YesNo_Clicked(Value) {
  return Value > -1;
}

export function ValidateStateCountyTownship(Value) {
  return;
  {
    (Value != "" &&
      this.HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere == 1 &&
      Value != null) ||
      this.HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere == 0;
  }
}

export function ValidateSpouseRequiredFields(Value) {
  var isValid =
    Value != "" ||
    this.HomesteadQuestionnaire.SpouseOrAdditionalDeededOwner_NotApplicable;

  return isValid;
}

export function ValidateSpouse_SSN(Value) {
  var isInvalid =
    Value == "" &&
    !this.HomesteadQuestionnaire.SpouseOrAdditionalDeededOwner_NotApplicable &&
    this.HomesteadQuestionnaire.SpouseDLNumber == "";

  //if a value is supplied, it must be 5 characters
  if (
    !isInvalid &&
    !this.HomesteadQuestionnaire.SpouseOrAdditionalDeededOwner_NotApplicable
  ) {
    isInvalid = Value.length > 0 && Value.length != 5;
  }

  return !isInvalid;
}

export function ValidateSpouse_DL_Number(Value) {
  var isInvalid =
    Value == "" &&
    !this.HomesteadQuestionnaire.SpouseOrAdditionalDeededOwner_NotApplicable &&
    this.HomesteadQuestionnaire.SpouseSSNLastFive == "";

  //if a value is supplied, it must be 5 characters
  if (!isInvalid) {
    isInvalid = Value.length > 0 && Value.length != 5;
  }
  return !isInvalid;
}

export function ValidateClaimant_DL_State(Value) {
  var isInvalid =
    Value.length == 0 && this.HomesteadQuestionnaire.ClaimantSSNLastFive == "";

  return !isInvalid;
}

export function ValidateSpouse_DL_State(Value) {
  var isInvalid =
    Value.length == 0 &&
    !this.HomesteadQuestionnaire.SpouseOrAdditionalDeededOwner_NotApplicable &&
    this.HomesteadQuestionnaire.SpouseSSNLastFive == "";

  return !isInvalid;
}

export function ValidateClaimant_SSN(Value) {
  var isInvalid =
    Value == "" && this.HomesteadQuestionnaire.ClaimantDLNumber == "";

  //if a value is supplied, it must be 5 characters
  if (!isInvalid) {
    isInvalid = Value.length > 0 && Value.length != 5;
  }
  return !isInvalid;
}

export function ValidateClaimant_DL_Number(Value) {
  var isInvalid =
    Value == "" && this.HomesteadQuestionnaire.ClaimantSSNLastFive == "";
  //if a value is supplied, it must be 5 characters
  if (!isInvalid) {
    isInvalid = Value.length > 0 && Value.length != 5;
  }
  return !isInvalid;
}

export function ValidateOtherPropertyStateCountyTownship(Value) {
  var isInvalid =
    Value == "" &&
    this.HomesteadQuestionnaire.ClaimantPropertyOwnedElsewhere == 1;

  return !isInvalid;
}

export function ValidateVacatedHomesteadAddress(Value) {
  var isInvalid =
    Value == "" && this.HomesteadQuestionnaire.ClaimaintVacatingHomestead == 1;

  return !isInvalid;
}

export function ValidateContractSeller(Value) {
  var isInvalid =
    Value == "" && this.HomesteadQuestionnaire.OwnershipStatus == "B";

  return !isInvalid;
}

export default {
  name: "HomesteadQuestionnaire",
  props: {
    HomesteadQuestionnaire: {
      type: Object,
      required: true
    },
    v: {
      type: Object,
      required: true
    },
    CorpCode: {
      type: String,
      required: true
    }
  },

  watch: {
    "HomesteadQuestionnaire.ClaimantMarried": function(val, preVal) {
      //if the client is married the not applicable flag must be false
      if (val == 1) {
        this.HomesteadQuestionnaire.SpouseOrAdditionalDeededOwner_NotApplicable = false;
      }
    }
  },
  validations: {
    HomesteadQuestionnaire: {
      OwnershipStatus: {
        required
      },
      ContractSeller: {
        ValidateContractSeller
      },
      ClaimantSSNLastFive: {
        ValidateClaimant_SSN
      },
      ClaimantDLNumber: {
        ValidateClaimant_DL_Number
      },
      ClaimantDLState: {
        ValidateClaimant_DL_State
      },
      ClaimaintVacatingHomestead: {
        YesNo_Clicked
      },
      ClaimantPropertyOwnedElsewhere: {
        YesNo_Clicked
      },
      OtherPropertyStateCountyTownship: {
        ValidateOtherPropertyStateCountyTownship
      },
      VacatedHomesteadAddress: {
        ValidateVacatedHomesteadAddress
      },
      ClaimantMarried: {
        YesNo_Clicked
      },
      SpouseDLNumber: {
        ValidateSpouse_DL_Number
      },
      SpouseDLState: {
        ValidateSpouse_DL_State
      },
      SpouseSSNLastFive: {
        ValidateSpouse_SSN
      },
      SpouseClaimantFirstName: {
        ValidateSpouseRequiredFields
      },
      SpouseClaimantLastName: {
        ValidateSpouseRequiredFields
      },
      SpouseTelephoneNumber: {
        ValidateSpouseRequiredFields,
        minLength: minLength(12)
      }
    }
  }
};
</script>
